module.exports = __webpack_public_path__ + "static/kobold_dragonshield-25bf0d1a6d0789831337b4a27846adc0.jpeg";